module.exports = __webpack_public_path__ + "static/media/appleIcon.4c104b22.svg";